"use client";

import React from "react";
import { CustomRequireActiveTenancy } from "./custom-require-active-tenancy";

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class CustomRequireActiveTenancyErrorBoundary extends React.Component<
  { children: React.ReactNode },
  ErrorBoundaryState
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Error in CustomRequireActiveTenancy:", error, errorInfo);
    
    // If it's a length error, it's likely a data structure issue
    if (error.message?.includes("length")) {
      // Reset error state after a short delay to retry
      setTimeout(() => {
        this.setState({ hasError: false, error: null });
      }, 1000);
    }
  }

  render() {
    if (this.state.hasError) {
      // Return null to prevent crash, the component will retry
      return null;
    }

    return this.props.children;
  }
}

export const CustomRequireActiveTenancyWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <CustomRequireActiveTenancyErrorBoundary>
      <CustomRequireActiveTenancy>{children}</CustomRequireActiveTenancy>
    </CustomRequireActiveTenancyErrorBoundary>
  );
};

